import { useMemo, useState } from 'react';

import type { ColumnSizingState } from '../types/tanstack-table-types';

/**
 * Тип размеров колонок грида.
 */
export interface GridColumnSizing {
    /**
     * Стейт размеров колонок грида.
     */
    columnSizing: ColumnSizingState;
    /**
     * Обработчик изменения размеров колонок грида.
     */
    setColumnSizing: (
        columnSizing: ColumnSizingState | ((columnSizing: ColumnSizingState) => ColumnSizingState)
    ) => void;
}

/**
 * Возвращает стейт для хранения размеров колонок грида и обработчик для изменения стейта.
 *
 * @param initialColumnSizing Начальный стейт размеров колонок грида.
 * @returns Стейт размеров колонок и обработчик изменения.
 */
export function useGridColumnSizing(initialColumnSizing: ColumnSizingState = {}): GridColumnSizing {
    const [columnSizing, setColumnSizing] = useState<ColumnSizingState>(initialColumnSizing);

    return useMemo(() => ({ columnSizing, setColumnSizing }), [columnSizing, setColumnSizing]);
}
